import parseAPNG from 'talkr-apng'
import EventEmitter from 'events'
class APNGLoader {
  loadAsStaticImage (data, id, onLoaded, onError) {
    var reader = new FileReader()
    reader.onloadend = function () {
      const canvas = document.createElement('canvas')
      APNGLoader.cachedAPNG[id] = canvas
      canvas.id = id
      const context = canvas.getContext('2d')
      canvas.apng_player = null
      var image = new Image()
      image.onload = function () {
        canvas.width = this.width
        canvas.height = this.height
        context.drawImage(this, 0, 0)
        if (onLoaded) {
          if (id) {
            APNGLoader.eventEmitter.emit('canvasAdded', id)
            onLoaded(APNGLoader.cachedAPNG[id])
          } else {
            onLoaded(canvas)
          }
        }
      }
      image.src = this.result
    }
    reader.onloaderror = function () {
      if (onError) onError('Not a APNG')
    }
    reader.readAsDataURL(data)
  }
  loadCachedAPNGData (id, onLoaded, onError) {
    if (id in APNGLoader.cachedAPNG) {
      if (onLoaded) onLoaded(APNGLoader.cachedAPNG[id])
    } else {
      if (onError) {
        onError()
      }
    }
  }
  loadAPNGData (data, id, onLoaded, onError) {
    setTimeout(() => {
      // parseAPNG is destructive.  You can only run it once on the data
      var dataCopy = new Uint8Array(data)
      const apng = parseAPNG(dataCopy)
      if (apng instanceof Error) {
        console.warn('loading as static: ' + id)
        this.loadAsStaticImage(new Blob([dataCopy]), id, onLoaded, onError)
        return
      }
      // Make sure we only try to load this once
      // If someone else tries to load while we are loading, they will get the blank canvas
      const canvas = document.createElement('canvas')
      APNGLoader.cachedAPNG[id] = canvas
      canvas.id = id
      apng.createImages().then(() => {
        canvas.width = apng.width
        canvas.height = apng.height
        apng.getPlayer(canvas.getContext('2d')).then(p => {
          canvas.apng_player = p
          APNGLoader.cachedAPNG[id] = canvas
          p.playbackRate = 1.0
          if (onLoaded) {
            APNGLoader.eventEmitter.emit('canvasAdded', id)
            onLoaded(canvas)
          }
        })
      })
    }, 0)
  }
  loadAPNG (id, url, onLoaded, onError) {
    if (id in APNGLoader.cachedAPNG) {
      if (APNGLoader.cachedAPNG[id]) {
        this.loadCachedAPNGData(id, onLoaded, onError)
      } else {
        onError('null canvas in APNGLoader.cachedAPNG')
      }
      return
    } else if (!url) {
      onError('url is null, but I do not have a local copy')
      return
    }
    if (id in APNGLoader.loadingCallbacks) {
      APNGLoader.loadingCallbacks[id].push({onLoaded: onLoaded, onError: onError})
    } else {
      APNGLoader.loadingCallbacks[id] = []
      APNGLoader.loadingCallbacks[id].push({onLoaded: onLoaded, onError: onError})

      var loadSuceeded = (canvas) => {
        for (var i = 0; i < APNGLoader.loadingCallbacks[id].length; ++i) {
          APNGLoader.loadingCallbacks[id][i].onLoaded(canvas)
        }
      }
      var loadFailed = (error) => {
        for (var i = 0; i < APNGLoader.loadingCallbacks[id].length; ++i) {
          APNGLoader.loadingCallbacks[id][i].onError(error)
        }
      }
      let xhr = new XMLHttpRequest()
      xhr.onreadystatechange = (oEvent) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 403) {
            if (onError) onError(xhr.status)
          } else if (xhr.status !== 200) {
            if (onError) onError()
          } else {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              this.loadAPNGData(xhr.response, id, loadSuceeded, loadFailed)
            }
          }
        }
      }
      xhr.open('GET', url, true)
      xhr.responseType = 'arraybuffer'
      xhr.send(null)
    }
  }
  removeAPNGData (url) {
    if (url in APNGLoader.cachedAPNG) {
      delete APNGLoader.cachedAPNG[url]
    }
  }
}

APNGLoader.storageKey = 'localGIFFile_'
APNGLoader.thumbstorageKey = 'thumblocalGIFFile_'
APNGLoader.indexStorageKey = 'localFileIndex'
APNGLoader.lengthStorageKey = 'localFileSize'

APNGLoader.storage = {
  getItem: function (key) {
    try {
      return localStorage.getItem(key)
    } catch (e) {
      return null
    }
  },
  setItem: function (key, data) {
    try {
      localStorage.setItem(key, data)
      if (localStorage.getItem(key)) {
        return true
      }
      // iOS on Safari can take time to set the key, making it difficult to test if the set worked.
      // So this return statement is pretty useless
      return false
    } catch (e) {
      return null
    }
  },
  removeItem: function (key) {
    try {
      return localStorage.removeItem(key)
    } catch (e) {
      return null
    }
  }
}

APNGLoader.storeAsString = function (byteArray) {
  if (!(byteArray instanceof ArrayBuffer)) {
    console.warn(typeof byteArray)
    throw new Error('storeAsString requres an ArrayBuffer')
  }
  let TYPED_ARRAY = new Uint8Array(byteArray)
  // const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);
  const STRING_CHAR = TYPED_ARRAY.reduce((dat, byte) => {
    return dat + String.fromCharCode(byte)
  }, '')
  let base64String = btoa(STRING_CHAR)
  return base64String
}

APNGLoader.blobToBase64 = function (apngBlob, thumbBlob, id, onSuccess, onFailure) {
  // https://stackoverflow.com/questions/18650168/convert-blob-to-base64
  var blobToBase64 = function (blob, callback) {
    var reader = new FileReader()
    reader.onload = function () {
      var dataUrl = reader.result
      var base64 = dataUrl.split(',')[1]
      callback(base64)
    }
    reader.onerror = function (error) {
      if (onFailure) onFailure(error)
    }
    reader.readAsDataURL(blob)
  }
  blobToBase64(apngBlob, (apngBase64) => {
    blobToBase64(thumbBlob, (thumbBase64) => {
      if (onSuccess) onSuccess(apngBase64, thumbBase64)
    })
  })
}
APNGLoader.saveAPNGLocally = function (apngBase64, thumbBase64, id, onSuccess, onFailure) {
  var length = 0
  var l = APNGLoader.storage.getItem(APNGLoader.lengthStorageKey)
  if (l) {
    length = parseInt(l)
  }
  // Chrome allows 5MB of localstorage
  // Assuming we are sharing content with the pics, reserve 1MB for content and allow for the rest to be pics
  if (length + apngBase64.length + thumbBase64.length > 4000000) {
    if (onFailure) onFailure('Over space limitation!')
    return
  }
  if (!APNGLoader.storage.setItem(APNGLoader.storageKey + id, apngBase64) ||
  APNGLoader.storage.setItem(APNGLoader.thumbstorageKey + id, thumbBase64)) {
    // iOS on Safari can take time to set the key, making it difficult to test if it worked.
  }
  length += apngBase64.length + thumbBase64.length
  var filedict = {}
  var filedictString = APNGLoader.storage.getItem(APNGLoader.indexStorageKey)
  if (filedictString) {
    filedict = JSON.parse(filedictString)
  }
  filedict[id] = 1
  APNGLoader.storage.setItem(APNGLoader.indexStorageKey, JSON.stringify(filedict))
  APNGLoader.storage.setItem(APNGLoader.lengthStorageKey, length)
  if (onSuccess) onSuccess()
}

// https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
APNGLoader.convertDataURIToBinary = function (b64Data, sliceSize = 512) {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  return byteArrays
}

APNGLoader.deleteLocalAPNGFile = function (key) {
  var length = APNGLoader.storage.getItem(APNGLoader.lengthStorageKey)
  var apng = APNGLoader.storage.getItem(APNGLoader.storageKey + key)
  var thumb = APNGLoader.storage.getItem(APNGLoader.thumbstorageKey + key)
  if (apng) {
    length -= apng.length
  } else {
    console.warn('could not delete apng: ' + key)
  }
  if (thumb) {
    length -= thumb.length
  } else {
    console.warn('could not delete thumb: ' + key)
  }

  APNGLoader.storage.removeItem(APNGLoader.storageKey + key)
  APNGLoader.storage.removeItem(APNGLoader.thumbstorageKey + key)

  var filedict = {}
  var filedictString = APNGLoader.storage.getItem(APNGLoader.indexStorageKey)
  if (filedictString) {
    filedict = JSON.parse(filedictString)
  }
  delete filedict[key]
  APNGLoader.storage.setItem(APNGLoader.indexStorageKey, JSON.stringify(filedict))
  APNGLoader.storage.setItem(APNGLoader.lengthStorageKey, length)
}

APNGLoader.getLocalAPNGasBlob = function (key) {
  var localFile = APNGLoader.storage.getItem(APNGLoader.storageKey + key)
  if (localFile) {
    const blob = new Blob(APNGLoader.convertDataURIToBinary(localFile), {type: 'image/png'})
    return blob
  } else {
    throw new Error('no apng')
  }
}
APNGLoader.getLocalThumbasBlob = function (key) {
  var localFile = APNGLoader.storage.getItem(APNGLoader.thumbstorageKey + key)
  if (localFile) {
    const blob = new Blob(APNGLoader.convertDataURIToBinary(localFile), {type: 'image/jpg'})
    return blob
  } else {
    throw new Error('no thumb')
  }
}

APNGLoader.getLocalAPNG = function (key, base64Apng, base64Thumb) {
  var file = {}
  file.apng = 'data:image/png;base64, ' + base64Apng
  file.thumb = 'data:image/jpg;base64, ' + base64Thumb
  return file
}

APNGLoader.getLocalAPNGFromStorage = function (key) {
  var base64Apng = APNGLoader.storage.getItem(APNGLoader.storageKey + key)
  var base64Thumb = APNGLoader.storage.getItem(APNGLoader.thumbstorageKey + key)
  if (base64Apng && base64Thumb) {
    return APNGLoader.getLocalAPNG(key, base64Apng, base64Thumb)
  } else {
    // throw new Error('error retrieving apng from storage: ' + key)
    console.warn('error retrieving apng from storage: ' + key)
    APNGLoader.deleteLocalAPNGFile(key)
    return null
  }
}
APNGLoader.getLocalAPNGs = function () {
  var indexStorageKey = APNGLoader.storage.getItem(APNGLoader.indexStorageKey)
  var files = {}
  if (indexStorageKey) {
    indexStorageKey = JSON.parse(indexStorageKey)
    for (var key in indexStorageKey) {
      var file = APNGLoader.getLocalAPNGFromStorage(key)
      if (file) {
        files[key] = file
      }
    }
  }
  return files
}

APNGLoader.cachedAPNG = {}
APNGLoader.loadingCallbacks = {}
APNGLoader.eventEmitter = new EventEmitter()

export default APNGLoader



// WEBPACK FOOTER //
// ./src/apng/index.js